import { render, staticRenderFns } from "./SidebarConservation.vue?vue&type=template&id=6353a7ee&"
import script from "./SidebarConservation.vue?vue&type=script&lang=js&"
export * from "./SidebarConservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports